import React from 'react'

const StatisticsTournamentComponent = () => {
  return (
    <div>StatisticsTournamentComponent</div>
  )
}

export default StatisticsTournamentComponent